// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8b81a313","703":"30f81475"}[chunkId] + ".chunk.js";
};